import { render, staticRenderFns } from "./SidebarScada.vue?vue&type=template&id=24490b30&"
import script from "./SidebarScada.vue?vue&type=script&lang=js&"
export * from "./SidebarScada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports